import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Button } from "../Button/Button";
import { TBGContext } from "../ToggleButtonGroup/ToggleButtonGroup";
const DEFAULT_TOGGLE_BUTTON_AS = "button";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ToggleButton = ({ children, active, ...rest }) => {
    const groupContext = React.useContext(TBGContext);
    return (_jsx(Button, { size: (groupContext === null || groupContext === void 0 ? void 0 : groupContext.size) || undefined, variant: active ? "primary" : "secondary", className: classNames("eds-toggle-button"), "aria-pressed": active, ...rest, children: children }));
};
